import React, { useState } from 'react';
import { Typography, Button, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import RequestAccessModal from '../RequestAccessModal/RequestAccessModal';
import { BASE_URL, IMAGE_PATHS } from '../../../constants/paths.constants';
import history from '../../../services/browserHistory';

const useStyles = makeStyles((theme: Theme) => ({
  bedTitleWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    height: 93,
  },
  bedLogo: {
    paddingLeft: 65,
    paddingTop: 16,
    width: 239,
    height: 63,
  },
  rightSide: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 24,
  },
  loginButton: {
    width: 108,
    borderRadius: '24px',
  },
  rightTextBlock: {
    paddingLeft: 16,
  },
  notRegistered: {
    fontSize: 12,
    paddingRight: 80,
  },
  requestAccess: {
    borderRadius: 0,
    height: '1em',
    padding: 0,
    textTransform: 'none',
    textDecoration: 'underline',
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
  },
}));

const BlueEarthTitleBar = (): JSX.Element => {
  const classes = useStyles();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleAccessModalOpen = (isOpen: boolean) => {
    history.push('/user-registration');
  };

  return (
    <div className={classes.bedTitleWrapper}>
      <img
        className={classes.bedLogo}
        src={`${BASE_URL}${IMAGE_PATHS.BED_LOGO.path}`}
        alt={`${IMAGE_PATHS.BED_LOGO.alt}`}
      />
      <div className={classes.rightSide}>
        <div>
          <Button
            color="secondary"
            variant="contained"
            className={classes.loginButton}
            onClick={() => history.push('/login')}
          >
            Login
          </Button>
        </div>
        <div className={classes.rightTextBlock}>
          <span>
            <Typography className={classes.notRegistered}>Not registered?&nbsp;</Typography>
            <Button size="small" className={classes.requestAccess} onClick={() => handleAccessModalOpen(true)}>
              Register
            </Button>
          </span>
        </div>
      </div>
      <RequestAccessModal isOpen={isModalOpen} handleModalOpen={(isOpen: boolean) => handleAccessModalOpen(isOpen)} />
    </div>
  );
};

export default BlueEarthTitleBar;
